import { jsx as n, Fragment as x, jsxs as I } from "react/jsx-runtime";
import { useRef as z, useState as b, useEffect as B } from "react";
import { I as L, a as S } from "./ic_arrowforward_fill-DIQoCdSY.mjs";
import { createPortal as $ } from "react-dom";
import { F as y } from "./floating-button-BY52IkIA.mjs";
import { c as E } from "./tw-cn-mXgPecoF.mjs";
const X = (g) => {
  const { id: p, hidden: u, size: m, top: f, arrowProps: F, zIndex: h = 120, positionStrategy: d = "absolute" } = g, { left: t, right: e } = F || {}, o = d === "fixed", a = f !== void 0, i = z(null), [r, P] = b({ top: 0, left: 0, width: 0, height: 0 }), [k, C] = b(!0), v = () => {
    if (a) return `${f}px`;
    if (o) return `${r.top + r.height / 2}px`;
  };
  return B(() => {
    var w;
    i.current = document.getElementById(p);
    const s = (w = i.current) == null ? void 0 : w.parentElement;
    if (!i.current || !s) {
      C(!1);
      return;
    }
    const l = () => {
      if (i.current) {
        const c = i.current.getBoundingClientRect();
        P({
          top: c.top + window.scrollY,
          left: c.left + window.scrollX,
          width: c.width,
          height: c.height
        });
      }
    };
    if (l(), !!o)
      return s.addEventListener("resize", l), s.addEventListener("scroll", l), () => {
        s.removeEventListener("resize", l), s.removeEventListener("scroll", l);
      };
  }, [p, u]), $(
    /* @__PURE__ */ n(x, { children: !u && k ? /* @__PURE__ */ I(x, { children: [
      !(t != null && t.hidden) && /* @__PURE__ */ n(
        "div",
        {
          className: E("-translate-x-1/2", {
            "top-1/2 -translate-y-1/2": !a
          }),
          style: {
            position: d,
            zIndex: h,
            top: v(),
            left: o ? `${r.left}px` : 0
          },
          children: /* @__PURE__ */ n(
            y,
            {
              disabled: !!(t != null && t.disabled),
              icon: /* @__PURE__ */ n(L, {}),
              onClick: t == null ? void 0 : t.onClick,
              size: m
            }
          )
        }
      ),
      !(e != null && e.hidden) && /* @__PURE__ */ n(
        "div",
        {
          className: E("translate-x-1/2", {
            "top-1/2 -translate-y-1/2": !a,
            "-translate-x-1/2": o
          }),
          style: {
            position: d,
            zIndex: h,
            top: v(),
            left: o ? `${r.left + r.width}px` : void 0,
            right: o ? void 0 : 0
          },
          children: /* @__PURE__ */ n(
            y,
            {
              disabled: !!(e != null && e.disabled),
              icon: /* @__PURE__ */ n(S, {}),
              onClick: e == null ? void 0 : e.onClick,
              size: m
            }
          )
        }
      )
    ] }) : null }),
    o ? document.body : i.current || document.body
  );
};
export {
  X as S
};
